import React, { Fragment } from 'react'
import {
    Select,
    SelectItem,
    SelectTrigger,
    SelectValue,
    SelectContent
} from './select'
import { Controller, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'

const SelectInput = ({ onValueChange, value, options = [], rules, errors, placeholder, className, name='', control, label, required, defaultValue, readOnly, errorShow = true, clearSelection = false }) => {
    const { control: formControl } = useForm()
    return (
        <Fragment>
            {label && <label className='grc-label block mb-1'>{label}{required && <span className='text-danger'>*</span>}</label>}
            <Controller
                defaultValue={defaultValue}
                name={name}
                control={control || formControl}
                rules={rules}
                render={({ field: { onChange } }) => (
                    <Select
                        key={name}
                        onValueChange={e => { if (!readOnly) { onValueChange(e, name); onChange(e); } }}
                        value={value || ''}
                        defaultValue={defaultValue}
                        disabled={readOnly}
                    >
                        <SelectTrigger className={`input-grc select-trigger ${className} ${readOnly ? 'read-only' : ''}`} disabled={readOnly}>
                            <SelectValue className='!text-[1rem]' placeholder={placeholder} />
                        </SelectTrigger>
                        <SelectContent>
                            <>
                            {options?.map((item, index) =>
                                <SelectItem value={item?.value} key={index}>{item?.label}</SelectItem>)}
                                {/* {clearSelection && <SelectItem className value={'clearSelection'} key={'clearSelection'}> Clear Selection</SelectItem> } */}
                        </>
                        </SelectContent>
                    </Select>
                )}
            />
            <p className='grc-error-msg text-danger'>{errorShow && errors && name && errors[name]?.message}</p>
        </Fragment>
    )
}

SelectInput.propTypes = {
    className: PropTypes.string,
    value: PropTypes.any,
    onValueChange: PropTypes.func,
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    errors: PropTypes.any,
    rules: PropTypes.object,
    control: PropTypes.any,
    message: PropTypes.any,
    required: PropTypes.bool,
    options: PropTypes.array,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    errorShow: PropTypes.bool,
    readOnly: PropTypes.bool // Added readOnly prop
}

SelectInput.defaultProps = {
    readOnly: false // Default value for readOnly prop
}

export default SelectInput
